import ScenesPermissions from './ScenesPermissions'

class PermissionsModel {
    constructor({ scenes = {} }) {
        this.scenes = new ScenesPermissions(scenes)
    }
}

export default PermissionsModel
